import { useState, useCallback, useEffect } from 'react';
import { InvisibleSmartCaptcha, SmartCaptcha as VisibleSmartCaptcha } from '@yandex/smart-captcha';
import { useModal } from 'mui-modal-provider';

import { SmartCaptchaProps } from './smart-captcha.models';
import { useUnknownErrorModal } from '../../../hooks';
import { OfflineErrorModal } from '../offline-error-modal';
import { useStyles } from './smart-captcha.styles';

export const SmartCaptcha = ({
  onSuccess, isVisible = false, isVisibleCaptcha = false, isReset, onChallengeHidden,
}: SmartCaptchaProps): JSX.Element => {
  const [resetCaptcha, setResetCaptcha] = useState(0);
  const siteKey = process.env.REACT_APP_SMART_CAPTCHA_KEY || '';
  const { showModal } = useModal();
  const showUnknownErrorModal = useUnknownErrorModal(showModal);
  const classes = useStyles();

  const handleChallengeHidden = useCallback((): void => {
    onChallengeHidden?.();
  }, [onChallengeHidden]);

  const handleError = useCallback((): void => {
    if (!navigator.onLine) {
      showModal(OfflineErrorModal, {});
      console.error('SmartCaptcha offline error');
      return;
    }

    showUnknownErrorModal();
  }, [showUnknownErrorModal]);

  useEffect((): () => void => {
    let isMounted = true;

    if (isMounted && isReset) {
      setResetCaptcha((prev: number): number => prev + 1);
    }

    return (): void => {
      isMounted = false;
    };
  }, [isReset]);

  useEffect((): () => void => {
    return (): void => setResetCaptcha((prev: number): number => prev + 1);
  }, []);

  return (
    <>
      {isVisibleCaptcha ? (
        <div className={classes.root}>
          <VisibleSmartCaptcha
            key={resetCaptcha}
            sitekey={siteKey}
            language="ru"
            onSuccess={onSuccess}
            onNetworkError={handleError}
            onJavascriptError={handleError}
            onTokenExpired={handleError}
            test={false}
          />
        </div>
      ) : (
        <InvisibleSmartCaptcha
          key={resetCaptcha}
          sitekey={siteKey}
          language="ru"
          onSuccess={onSuccess}
          visible={isVisible}
          onNetworkError={handleError}
          onJavascriptError={handleError}
          onTokenExpired={handleError}
          test={false}
          onChallengeHidden={handleChallengeHidden}
        />
      )}
    </>
  );
};
